import { FC } from 'react';
import { MainContentFixedWidth } from 'modules/intelligentInsights/IntelligentInsights.styles';
import { IntelligentInsightsBackground } from 'modules/intelligentInsights/frequencyOptimization/FrequencyOptimizationReporting.styles';
import { FrequencyOptimizationInsightsMainHeader } from 'modules/intelligentInsights/frequencyOptimization/components/FrequencyOptimizationInsightsMainHeader';
import { MediumBreakdown } from 'modules/intelligentInsights/frequencyOptimization/components/layout/MediumBreakdown';
import { PerformanceOverTime } from 'modules/intelligentInsights/frequencyOptimization/components/layout/PerformanceOverTime';

export const FrequencyOptimizationInsightsMainContent: FC = () => {
  return (
    <IntelligentInsightsBackground>
      <MainContentFixedWidth>
        <FrequencyOptimizationInsightsMainHeader />
      </MainContentFixedWidth>
      <PerformanceOverTime />
      <MediumBreakdown />
    </IntelligentInsightsBackground>
  );
};
